export function getElementSchemaFromArraySchema(fieldSchema) {
    switch (fieldSchema.elementType) {
        case 'object':
            if ('elementSubtype' in fieldSchema && fieldSchema.elementSubtype) {
                if (fieldSchema.elementSubtype === 'DateRange') {
                    // The DateRange subtype is slightly different from the others, and this seems to be the
                    // only way to appease TS
                    return {
                        type: 'object',
                        subtype: fieldSchema.elementSubtype,
                    };
                }
                return {
                    type: 'object',
                    subtype: fieldSchema.elementSubtype,
                };
            }
            if ('isFreeform' in fieldSchema && fieldSchema.isFreeform) {
                return {
                    type: 'object',
                    isFreeform: true,
                };
            }
            return {
                type: 'object',
                fields: fieldSchema.fields,
            };
        case 'float':
        case 'int':
            return {
                type: fieldSchema.elementType,
                ...('elementValues' in fieldSchema &&
                    fieldSchema.elementValues && { values: fieldSchema.elementValues }),
            };
        case 'keyString':
            return {
                type: 'keyString',
                ...('elementValidationRegex' in fieldSchema &&
                    fieldSchema.elementValidationRegex && {
                    validationRegex: fieldSchema.elementValidationRegex,
                }),
            };
        case 'stringEnum':
            return {
                type: 'stringEnum',
                enum: fieldSchema.elementEnum,
                ...(fieldSchema.elementValues && { values: fieldSchema.elementValues }),
                ui: 'dropdown',
            };
        case 'bool':
            return {
                type: 'bool',
            };
        case 'codeString':
        case 'dayTimestamp':
        case 'email':
        case 'mongoId':
        case 'password':
        case 'url':
            return { type: fieldSchema.elementType };
        case 'phone':
        case 'price':
        case 'timestamp':
            return { type: fieldSchema.elementType };
        case 'longString':
        case 'shortString':
            return { type: fieldSchema.elementType };
    }
}
//# sourceMappingURL=get_element_schema_from_array_schema.js.map